<app-header class="unselectable"></app-header>
<router-outlet></router-outlet>
<app-footer class="unselectable"></app-footer>